<div class="container-fluid">
  <!-- Back Button (only show when not embedded) -->
  <div class="row" *ngIf="!isEmbedded">
    <img
      class="imgBack cursor-pointer"
      (click)="goBack()"
      src="assets/img/backbtn.png"
      alt="Back"
    />
  </div>

  <!-- Header with Action Button -->
  <div class="col-md-12 mt-3">
    <div class="header-container">
      <div class="header-content">
        <h4 class="section-header">
          {{
            mode === "view"
              ? "View Template"
              : mode === "edit"
              ? "Edit Template"
              : "Add Exercises to the Template"
          }}
        </h4>
        <p class="section-description">
          {{
            mode === "view"
              ? "Review the template details and exercises"
              : mode === "edit"
              ? "Update the template details and exercises"
              : "Review and configure the daily exercise routine before saving the template"
          }}
        </p>
      </div>
      <div class="header-actions">
        <button
          *ngIf="mode === 'view'"
          class="btn btn-secondary me-2"
          (click)="editTemplate()"
        >
          Edit Template
        </button>
        <button
          *ngIf="mode === 'edit' && templateId"
          class="btn btn-danger me-2"
          (click)="showDeleteModal()"
          title="Delete Template"
        >
          <mat-icon>delete</mat-icon>
        </button>
        <button
          *ngIf="mode !== 'view'"
          class="btn btn-primary save-template-btn"
          (click)="saveTemplate()"
        >
          {{ mode === "edit" ? "Update Template" : "Save Template" }}
        </button>
      </div>
    </div>
  </div>

  <hr class="mt-2" />

  <!-- Template Details -->
  <div class="col-md-12 mt-4">
    <div class="template-details-container">
      <div class="template-details-grid">
        <div class="template-name-column">
          <div class="form-group">
            <label for="templateName">Template Name</label>
            <input
              type="text"
              id="templateName"
              class="form-control"
              [(ngModel)]="templateName"
              [readonly]="isReadonly"
              placeholder="e.g., Beginner Strength Training"
            />
          </div>
        </div>
        <div class="template-description-column">
          <div class="form-group">
            <label for="templateDescription">Description (Optional)</label>
            <textarea
              id="templateDescription"
              class="form-control"
              [(ngModel)]="templateDescription"
              [readonly]="isReadonly"
              placeholder="Brief description of the template"
              rows="3"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Weekly Template Accordion -->
  <div class="col-md-12 mt-4">
    <div class="date-accordion-container">
      <div
        class="accordion-item mb-3 accordion-item-container"
        *ngFor="let day of weeklyTemplate; let i = index"
      >
        <!-- Accordion Header -->
        <div
          class="accordion-header accordion-header-4part"
          (click)="toggleAccordion(i)"
        >
          <div class="date-section">
            <h6>{{ day.dayName }}</h6>
          </div>
          <div class="completion-section">
            <span *ngIf="day.isRestDay" class="completion-text default"
              >Rest Day</span
            >
            <span *ngIf="!day.isRestDay" class="completion-text default">
              {{
                getSectionExerciseCount(i, "warmup") +
                  getSectionExerciseCount(i, "main") +
                  getSectionExerciseCount(i, "cooldown")
              }}
              exercises
            </span>
          </div>
          <div class="button-section">
            <button
              class="btn btn-sm workout-day-btn"
              [ngClass]="day.isRestDay ? 'rest' : 'workout'"
              [disabled]="isReadonly"
              (click)="toggleDayRestDay(i); $event.stopPropagation()"
            >
              {{ day.isRestDay ? "Rest Day" : "Workout Day" }}
            </button>
          </div>
          <div class="exercise-info-section">
            <button
              *ngIf="!day.isRestDay && !isReadonly"
              class="btn btn-sm copy-from-btn"
              (click)="openCopyDayDialog(i); $event.stopPropagation()"
              title="Copy exercises from another day"
            >
              <mat-icon>content_copy</mat-icon>
              Copy From
            </button>
            <mat-icon
              class="expand-icon"
              [ngClass]="day.isExpanded ? 'expanded' : 'collapsed'"
            >
              expand_more
            </mat-icon>
          </div>
        </div>

        <!-- Accordion Content -->
        <div
          class="accordion-content accordion-content-container"
          *ngIf="day.isExpanded"
        >
          <div *ngIf="day.isRestDay" class="rest-day-container">
            <mat-icon class="rest-day-icon">bed</mat-icon>
            <p class="rest-day-title">Rest Day</p>
            <p class="rest-day-subtitle">No exercises for this day.</p>
          </div>

          <div *ngIf="!day.isRestDay" class="exercise-config">
            <div
              class="exercise-section mb-4"
              *ngFor="let section of exerciseSections"
            >
              <h6 class="exercise-section-header" [style.color]="section.color">
                {{ section.title }}
              </h6>
              <div
                class="exercise-container mb-3 exercise-container-styled"
                *ngFor="
                  let exercise of getExercisesBySection(i, section.key);
                  trackBy: trackById
                "
                [style.background]="section.background"
                [style.border-color]="section.border"
              >
                <div class="exercise-grid-row exercise-grid-layout">
                  <div class="exercise-dropdown-grid">
                    <select
                      class="form-control"
                      [(ngModel)]="exercise.exercise"
                      [disabled]="isReadonly"
                    >
                      <option value="" disabled>Select Exercise</option>
                      <option
                        *ngFor="let availableExercise of availableExercises"
                        [value]="availableExercise"
                      >
                        {{ availableExercise }}
                      </option>
                    </select>
                  </div>

                  <div class="sets-grid">
                    <div
                      class="set-row"
                      *ngFor="let set of exercise.sets; let k = index"
                    >
                      <span class="set-label">Set {{ k + 1 }}:</span>

                      <!-- Reps Input -->
                      <div class="set-input-container">
                        <input
                          type="number"
                          class="form-control small-input reps-input set-input"
                          [(ngModel)]="set.reps"
                          [readonly]="isReadonly"
                          placeholder="Reps"
                          min="0"
                        />
                      </div>

                      <!-- Time Input - Separate MM and SS fields -->
                      <div class="set-input-container time-inputs-container">
                        <div class="time-field-group">
                          <input
                            type="number"
                            class="form-control small-input time-minutes-input set-input"
                            [(ngModel)]="set.timeMinutes"
                            [readonly]="isReadonly"
                            (ngModelChange)="updateTotalSeconds(exercise, k)"
                            placeholder="MM"
                            min="0"
                            max="99"
                            title="Enter minutes (0-99)"
                          />
                          <span class="time-separator">:</span>
                          <input
                            type="number"
                            class="form-control small-input time-seconds-input set-input"
                            [(ngModel)]="set.timeSeconds"
                            [readonly]="isReadonly"
                            (ngModelChange)="updateTotalSeconds(exercise, k)"
                            placeholder="SS"
                            min="0"
                            max="59"
                            title="Enter seconds (0-59)"
                          />
                        </div>
                      </div>

                      <!-- Weights Input -->
                      <div class="set-input-container">
                        <input
                          type="number"
                          class="form-control small-input weights-input set-input"
                          [(ngModel)]="set.weights"
                          [readonly]="isReadonly"
                          placeholder="Weight (lb)"
                          min="0"
                        />
                      </div>

                      <!-- Set Action Buttons -->
                      <div class="set-buttons-flex" *ngIf="!isReadonly">
                        <button
                          class="btn btn-sm add-set-btn"
                          (click)="addSetToExercise(i, exercise.id)"
                          *ngIf="k === exercise.sets.length - 1"
                        >
                          + Set
                        </button>
                        <button
                          class="btn btn-sm remove-set-btn"
                          (click)="removeSetFromExercise(i, exercise.id, k)"
                          *ngIf="exercise.sets.length > 1"
                        >
                          - Set
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="exercise-actions-grid" *ngIf="!isReadonly">
                    <div class="exercise-actions">
                      <button
                        class="btn add-exercise-btn"
                        [style.background-color]="section.buttonBg"
                        (click)="addExerciseToDay(i, section.key)"
                      >
                        <mat-icon class="add-exercise-icon">add</mat-icon>
                        {{
                          section.key === "main"
                            ? "Main"
                            : section.key === "warmup"
                            ? "Warmup"
                            : "Cooldown"
                        }}
                      </button>
                      <button
                        class="btn remove-exercise-btn"
                        (click)="removeExerciseFromDay(i, exercise.id)"
                      >
                        <mat-icon class="remove-exercise-icon">close</mat-icon>
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Validation Error Modal -->
<div class="modal-overlay" *ngIf="showValidationErrors">
  <div class="modal-container">
    <div class="modal-header">
      <h5>Validation Errors</h5>
      <button class="close-btn" (click)="closeValidationModal()">
        &times;
      </button>
    </div>
    <div class="modal-body">
      <p>Please fix the following issues:</p>
      <ul>
        <li *ngFor="let error of validationErrors">{{ error }}</li>
      </ul>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeValidationModal()">
        Close
      </button>
    </div>
  </div>
</div>

<!-- Success Modal -->
<div class="modal-overlay" *ngIf="showSuccessModal">
  <div class="modal-container">
    <div class="modal-header">
      <h5>Success</h5>
    </div>
    <div class="modal-body">
      <p>Fitness plan template created successfully!</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" (click)="closeSuccessModalAndRedirect()">
        OK
      </button>
    </div>
  </div>
</div>

<!-- Validation Errors Modal -->
<div class="modal-overlay" *ngIf="showValidationErrors">
  <div class="modal-container">
    <div class="modal-header">
      <h5>Validation Errors</h5>
      <button class="close-btn" (click)="closeValidationErrors()">×</button>
    </div>
    <div class="modal-body">
      <p>Please fix the following errors before saving the template:</p>
      <ul class="validation-errors-list">
        <li
          *ngFor="let error of validationErrors"
          class="validation-error-item"
        >
          {{ error }}
        </li>
      </ul>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" (click)="closeValidationErrors()">
        OK
      </button>
    </div>
  </div>
</div>

<!-- Empty Days Warning Modal -->
<div class="modal-overlay" *ngIf="showEmptyDaysWarning">
  <div class="modal-container">
    <div class="modal-header">
      <h5>Empty Days Warning</h5>
    </div>
    <div class="modal-body">
      <p>
        <strong>{{ emptyDaysCount }}</strong> day{{
          emptyDaysCount > 1 ? "s" : ""
        }}
        {{ emptyDaysCount > 1 ? "have" : "has" }} no exercises assigned.
      </p>
      <p>Do you want to continue saving the template with empty days?</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="cancelEmptyDaysSubmission()">
        Cancel
      </button>
      <button class="btn btn-primary" (click)="confirmEmptyDaysSubmission()">
        Continue
      </button>
    </div>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<div class="modal-overlay" *ngIf="showDeleteConfirmation">
  <div class="modal-container">
    <div class="modal-header">
      <h5>Delete Template</h5>
      <button class="close-btn" (click)="closeDeleteModal()">×</button>
    </div>
    <div class="modal-body">
      <p><strong>Are you sure you want to delete this template?</strong></p>
      <p>
        This action cannot be undone. The template "{{ templateName }}" and all
        its exercises will be permanently deleted.
      </p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeDeleteModal()">
        Cancel
      </button>
      <button class="btn btn-danger" (click)="confirmDeleteTemplate()">
        Delete Template
      </button>
    </div>
  </div>
</div>
